/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from './defs.defs'

const $nsid = 'com.atproto.server.getAccountInviteCodes'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  includeUsed: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), true),
  ),
  createAvailable: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), true),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  codes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
      (() => ServerDefs.inviteCode) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get all invite codes for the current account. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['DuplicateCreate'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
